import React from 'react'
import BreadCrumb from '../ass_components/BreadCrumb'
import Meta from '../ass_components/Meta'

const RefundPolicy = () => {
  return (
    <>
    <Meta title={"Details"}/>
    <BreadCrumb title="Contenu d'article"/>
    <div className='wishlist-wrapper assiganto-home-wrapper-2 py-5'>
      <div className='container-xxl'>
        <div className='row'>
            <div className='col-12'>
                <div className='policy'>

                </div>
            </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default RefundPolicy